import { api } from "@/services/base"
import useStore from "@/store"

export interface GetVersionRes {
  version: string
}

export async function getVersion() {
  const res = await api
    .get<GetVersionRes>("version.json", {
      prefixUrl: "/",
    })
    .json()

  const store = useStore.getState()
  store.app.actions.setVersion(res.version)

  return res
}
